var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Vue, Component, Prop, Ref, toNative } from "vue-facing-decorator";
import { SystemComponentQueryModel } from "@/app/api/battery-portal-api";
let ComponentTreeVue = class ComponentTreeVue extends Vue {
    constructor() {
        super(...arguments);
        this.isExpanded = false;
    }
    get selectedNodesModel() {
        return this.selectedNodes;
    }
    set selectedNodesModel(value) {
        this.$emit("update:selectedNodes", value);
    }
    get hasChildren() {
        var _a, _b;
        return (_b = ((_a = this.item.children) === null || _a === void 0 ? void 0 : _a.length) > 0) !== null && _b !== void 0 ? _b : false;
    }
    get isSelected() {
        return this.selectedNodes.includes(this.item.componentId);
    }
    get cssClass() {
        return this.hasChildren ? "root" : "leaf";
    }
    get checkBoxCssClass() {
        if (!this.selectable)
            return "fa fa-circle-thin";
        if (this.isSelected)
            return "fa fa-check-circle-o checked";
        if (this.hasChildren && this.hasSelectedChildren)
            return "fa fa-stop-circle-o checked";
        return "fa fa-circle-thin";
    }
    get hasSelectedChildren() {
        const hasSelected = (children) => {
            if (!children)
                return false;
            for (const child of children) {
                if (this.selectedNodes.includes(child.componentId)) {
                    return true;
                }
                if (child.children && hasSelected(child.children)) {
                    return true;
                }
            }
            return false;
        };
        return hasSelected(this.item.children);
    }
    expand() {
        if (!this.hasChildren)
            return;
        this.isExpanded = !this.isExpanded;
    }
    toggleSelect() {
        if (!this.selectable)
            return;
        const newSelectedNodes = [...this.selectedNodes];
        const index = newSelectedNodes.indexOf(this.item.componentId);
        if (index === -1) {
            newSelectedNodes.push(this.item.componentId);
            if (this.hasChildren) {
                this.addSelectableChildren(newSelectedNodes);
            }
            if (this.parentId && this.areAllSiblingsSelected(newSelectedNodes)) {
                if (!newSelectedNodes.includes(this.parentId)) {
                    newSelectedNodes.push(this.parentId);
                }
            }
        }
        else {
            newSelectedNodes.splice(index, 1);
            if (this.hasChildren) {
                this.removeSelectableChildren(newSelectedNodes);
            }
            if (this.parentId && newSelectedNodes.includes(this.parentId)) {
                if (!this.areAllSiblingsSelected(newSelectedNodes)) {
                    const parentIdx = newSelectedNodes.indexOf(this.parentId);
                    if (parentIdx !== -1) {
                        newSelectedNodes.splice(parentIdx, 1);
                    }
                }
            }
        }
        this.selectedNodesModel = newSelectedNodes;
    }
    addSelectableChildren(nodes, children) {
        children = children !== null && children !== void 0 ? children : this.item.children;
        children === null || children === void 0 ? void 0 : children.forEach(child => {
            if (!nodes.includes(child.componentId)) {
                nodes.push(child.componentId);
            }
            if (child.children && child.children.length > 0) {
                this.addSelectableChildren(nodes, child.children);
            }
        });
    }
    removeSelectableChildren(nodes, children) {
        children = children !== null && children !== void 0 ? children : this.item.children;
        children === null || children === void 0 ? void 0 : children.forEach(child => {
            const index = nodes.indexOf(child.componentId);
            if (index !== -1) {
                nodes.splice(index, 1);
            }
            if (child.children && child.children.length > 0) {
                this.removeSelectableChildren(nodes, child.children);
            }
        });
    }
    areAllSiblingsSelected(nodes) {
        var _a, _b;
        if (!this.parentId)
            return false;
        const parent = this.$parent;
        const siblings = (_b = (_a = parent === null || parent === void 0 ? void 0 : parent.item) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
        return siblings.length > 0 && siblings.every((sibling) => nodes.includes(sibling.componentId));
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof SystemComponentQueryModel !== "undefined" && SystemComponentQueryModel) === "function" ? _a : Object)
], ComponentTreeVue.prototype, "item", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Number)
], ComponentTreeVue.prototype, "parentId", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], ComponentTreeVue.prototype, "selectable", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], ComponentTreeVue.prototype, "selectedNodes", void 0);
__decorate([
    Ref(),
    __metadata("design:type", typeof (_b = typeof Array !== "undefined" && Array) === "function" ? _b : Object)
], ComponentTreeVue.prototype, "children", void 0);
ComponentTreeVue = __decorate([
    Component({
        name: "ComponentTreeVue",
        emits: ["update:selectedNodes"],
    })
], ComponentTreeVue);
export default toNative(ComponentTreeVue);
